import type { LocalUiState } from '../types';
import { localUiClientJs } from './appClient';
import { localUiCss } from './appCss';

function escapeJsonForHtml(value: unknown): string {
  return JSON.stringify(value).replace(/</g, '\\u003c');
}

export function renderLocalUiHtml(state: LocalUiState): string {
  return `<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#0b0b0d" />
    <title>VibeRaven</title>
    <link rel="icon" type="image/png" href="/manga/favicon.png?v=manga1" />
    <link rel="shortcut icon" type="image/png" href="/manga/favicon.png?v=manga1" />
    <link rel="apple-touch-icon" href="/manga/favicon-180.png?v=manga1" />
    <link rel="preload" as="image" href="/report/assets/viberaven-mascot.png?v=raven-cards-2" />
    <style>${localUiCss}</style>
  </head>
  <body>
    <div id="vr-app" class="vr-app" aria-label="VibeRaven"></div>
    <script id="vr-state" type="application/json">${escapeJsonForHtml(state)}</script>
    <script src="/vendor/anime.umd.min.js"></script>
    <script>${localUiClientJs}</script>
  </body>
</html>`;
}
